import React from 'react'
import styled from 'styled-components'
import { WasteType } from '../../core/domain/models'
import WasteTypeRow from '../shared/WasteTypeRow'

export interface IDropOffLocationItemProps {
  onClick: () => void
  name: string
  picture?: string
  address?: {
    line: string
    zipCode: string
    countryCode: string
    city: string
    province?: string
  }
  wasteTypes: Array<WasteType>
  onShowAll?: () => void
}

const DropOffLocationItem: React.FC<IDropOffLocationItemProps> = ({
  name,
  picture,
  address,
  onClick,
  onShowAll,
  wasteTypes
}) => {
  let cityText = ''
  if (address?.zipCode) {
    cityText += address.zipCode
    cityText += ' '
  }
  if (address?.city) {
    cityText += address.city
  }

  return (
    <Container data-testid="dropOffLocation-container" onClick={onClick}>
      <InfoSection>
        <InfoWrapper>
          <div className="name" data-testid="name">
            {name}
          </div>
          {address && (
            <div className="address" data-testid="address">
              <div>{address.line}</div>
              {address.province && <div>{address.province}</div>}
              <div>
                <span>{cityText}</span>
              </div>
            </div>
          )}
        </InfoWrapper>
        {picture && <PictureWrapper image={picture} />}
      </InfoSection>
      {wasteTypes.length > 0 && (
        <WasteListSection>
          <WasteTypeRow wasteTypes={wasteTypes} onShowAll={onShowAll} withShowAllButton={true} />
        </WasteListSection>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};
  }
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 8px;
  padding: 16px 8px 8px 0;
`

const WasteListSection = styled.div`
  padding: 8px 0 16px 0;
`
interface IPictureWrapperProps {
  image: string
}

const PictureWrapper = styled.div<IPictureWrapperProps>`
  display: flex;
  flex-direction: column;
  height: 64px;
  min-height: 64px;
  width: 96px;
  min-width: 96px;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  border-radius: 4px;
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    font-family: ${({ theme }) => theme.font.semi};
    font-size: ${({ theme }) => theme.size.small};
  }

  .address {
    font-size: ${({ theme }) => theme.size.smaller};
    display: flex;
    flex-direction: column;
  }
`

export default DropOffLocationItem
